/*
  Inline icon re-hydration.

  blocks/inline-icon.liquid renders its icon into a <template> and then uses an
  inline <script> to append that template's content into the [data-icon-slot]
  placeholders that godlike-heading / godlike-text leave behind. That script is
  one-shot and relies on document.currentScript.

  Scripts inserted via innerHTML never execute. The cart drawer re-renders by
  replacing #CartDrawer's innerHTML (see PREMIUM_BLOCKS.md), so after any cart
  mutation the freshly fetched markup arrives with empty slots and an inert
  script, and every inline icon in the drawer silently disappears. It is not
  specific to any one block: godlike-heading, godlike-text and inline-icon all
  use the same slot mechanism.

  This re-runs the same append for slots that are still empty. It reads only
  attributes the blocks already emit — data-icon-for on the template, matched to
  data-icon-slot on the placeholder, scoped to the shared .sw-block ancestor —
  so nothing in the Sugar blocks had to change.

  Idempotent by construction: a slot that already has content is skipped, so
  running it repeatedly (and over nodes that never lost their icons) is a no-op.
*/
(function () {
  if (window.__inlineIconRehydrate) return;
  window.__inlineIconRehydrate = true;

  function fill(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var templates;
    try {
      templates = scope.querySelectorAll('template[data-icon-for]');
    } catch (e) {
      return;
    }
    for (var i = 0; i < templates.length; i++) {
      var tpl = templates[i];
      var owner = tpl.closest ? tpl.closest('.sw-block') : null;
      if (!owner) continue;
      var slot = tpl.getAttribute('data-icon-for');
      if (!slot) continue;
      var targets = owner.querySelectorAll('[data-icon-slot="' + slot + '"]');
      for (var j = 0; j < targets.length; j++) {
        /* Only an untouched slot is filled. The inline script has already run
           for anything server-rendered on this page load. */
        if (targets[j].firstChild) continue;
        try {
          targets[j].appendChild(tpl.content.cloneNode(true));
        } catch (e) {
          /* A malformed template must never take the drawer down. */
        }
      }
    }
  }

  function run(scope) {
    fill(scope || document);
  }

  var queued = false;
  function schedule(scope) {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      run(scope);
    });
  }

  function observe(el) {
    if (!el || el.__iiObserved) return;
    el.__iiObserved = true;
    try {
      new MutationObserver(function () {
        schedule(el);
      }).observe(el, { childList: true, subtree: true });
    } catch (e) {
      /* No observer support: the listeners below still cover cart refreshes. */
    }
  }

  function attach() {
    run(document);
    /* The <cart-drawer> host survives renderContents(), which swaps the
       #CartDrawer inside it — so the host is the stable thing to watch.
       cart-items covers the full cart page, which re-renders the same way. */
    var hosts = document.querySelectorAll('cart-drawer, cart-items, #main-cart-items');
    for (var i = 0; i < hosts.length; i++) observe(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  /* Belt and braces: the theme dispatches this after cart mutations, and it
     also fires for re-renders that replace a host the observer was watching. */
  document.addEventListener('cart:refresh', function () {
    schedule(document);
    attach();
  });
})();
